var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import ImageLoader from "./ImageLoader.js";
import { PixiSpriteLoader } from "./PixiSpriteLoader.js";
import { a as assignGlobalSingleton } from "../global-33d5eebf.js";
import "pixi.js";
const defaultOptions = {
  width: 0,
  height: 0,
  spacing: 0,
  margin: 0,
  zIndex: 0
};
class SpriteLoader {
  constructor() {
    __publicField(this, "spriteCache", {});
    __publicField(this, "promises", []);
    __publicField(this, "app", null);
  }
  static getInstance() {
    return assignGlobalSingleton("SpriteLoader", () => new SpriteLoader());
  }
  loadSprite(name, url, options) {
    if (this.spriteCache[name]) {
      let spriteUrl;
      if (Array.isArray(this.spriteCache[name])) {
        const first = this.spriteCache[name][0];
        spriteUrl = first.url;
        if (spriteUrl !== url) {
          return Promise.reject(`Sprite ${name} already loaded with url ${spriteUrl}`);
        }
        return Promise.resolve(name);
      }
      spriteUrl = this.spriteCache[name].url;
      if (spriteUrl !== url) {
        return Promise.reject(`Sprite ${name} already loaded with url ${spriteUrl}`);
      }
      return this.spriteCache[name].promise;
    }
    const spriteOptions = {
      ...defaultOptions,
      ...options ?? {}
    };
    const spritePromise = new Promise(async (resolve, reject) => {
      try {
        const image = await ImageLoader.getInstance().loadImage(name, url, {
          skipPixi: true
        });
        const imageWidth = image.image.width;
        const imageHeight = image.image.height;
        const spriteWidth = spriteOptions.width || imageWidth;
        const spriteHeight = spriteOptions.height || imageHeight;
        const spriteSpacing = spriteOptions.spacing;
        const spriteMargin = spriteOptions.margin;
        const sprites = [];
        for (let y = 0; y < imageHeight; y += spriteHeight + spriteMargin) {
          for (let x = 0; x < imageWidth; x += spriteWidth + spriteSpacing) {
            sprites.push({
              image: image.image,
              name,
              url,
              frameNumber: sprites.length,
              x,
              y,
              width: spriteWidth,
              height: spriteHeight,
              next: null,
              prev: null,
              first: null,
              last: null,
              xoffset: spriteOptions.xoffset ?? 0,
              yoffset: spriteOptions.yoffset ?? 0,
              zIndex: spriteOptions.zIndex ?? 0
            });
          }
        }
        const first = sprites[0];
        const last = sprites[sprites.length - 1];
        const subSpriteContainer = {};
        sprites.forEach((sprite, index) => {
          if (index > 0) {
            sprite.prev = sprites[index - 1];
            sprites[index - 1].next = sprite;
          }
          if (index === 0) {
            sprite.first = first;
            sprite.last = last;
          }
          if (index === sprites.length - 1) {
            sprite.first = first;
            sprite.last = last;
          }
        });
        if (spriteOptions.structure) {
          const aliases = spriteOptions.aliases ?? [""];
          let offset = 0;
          aliases.forEach((alias) => {
            const aliasName = alias ? alias : name;
            if (!spriteOptions.structure) {
              return;
            }
            spriteOptions.structure.forEach((structure) => {
              const structureNames = Array.isArray(structure.name) ? structure.name : [structure.name];
              let suboffset = 0;
              structureNames.forEach((subName) => {
                const subSprites = [];
                const structureName = `${aliasName}_${subName}`;
                for (let i = 0; i < sprites.length; i++) {
                  const sprite = { ...sprites[offset + i] };
                  sprite.name = structureName;
                  sprite.xoffset = structure.xoffset ?? sprite.xoffset;
                  sprite.yoffset = structure.yoffset ?? sprite.yoffset;
                  subSprites.push(sprite);
                  if (subSprites.length === structure.frames) {
                    break;
                  }
                }
                subSprites[0].first = null;
                subSprites[subSprites.length - 1].last = null;
                this.spriteCache[structureName] = subSprites;
                subSpriteContainer[structureName] = subSprites;
                if (suboffset === 0) {
                  suboffset += structure.frames;
                }
              });
              offset += suboffset;
            });
          });
        }
        this.spriteCache[name] = sprites;
        await PixiSpriteLoader.getInstance().loadSprite(name, url, sprites, subSpriteContainer);
        resolve(name);
      } catch (error) {
        reject(error);
      }
    });
    this.spriteCache[name] = { url, promise: spritePromise };
    this.promises.push(spritePromise);
    return spritePromise;
  }
  waitForAll() {
    return Promise.all(this.promises).then(() => {
      this.promises = [];
      return true;
    });
  }
  get(name, index) {
    if (this.promises.length) {
      throw new Error("Sprites not loaded");
    }
    if (!this.spriteCache[name]) {
      throw new Error(`Sprite ${name} not loaded`);
    }
    if (index !== void 0) {
      return this.spriteCache[name][index];
    }
    return this.spriteCache[name];
  }
}
export {
  SpriteLoader as default
};
//# sourceMappingURL=SpriteLoader.js.map
